import React from "react"
import { WhiteDiv } from "../components/whitediv"
import { Layout } from "../components/baselayout"
import { OfficerBox } from "../components/officerbox"
import { Email } from "../components/email"
const master = require("../images/committee/Stella.jpg")
const assmaster = require("../images/committee/Jonny.jpg")
const secretary = require("../images/committee/Greg.jpeg")
const steeplekeeper = require("../images/committee/Chris.jpg")
const librarian = require("../images/committee/Harry.jpg")
const teaching = require("../images/committee/Dima.jpg")

const About: React.FC = () => (
  <Layout title="About Us">
    <WhiteDiv>
      <h1>About Us</h1>
      <hr />
      <p>
        Anyone who rings bells is welcome!
        <br />
        <br />
        We have fun meetings twice a week, and sometimes some SPECIAL EVENTS!
      </p>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          justifyContent: "center",
        }}
      >
        <OfficerBox
          role="Very Important Leader"
          name="Stella"
          college="Christ's"
          jobDesc="Tells us what to do!"
          email="master@cugcr.org.uk"
          picture={master}
        />
        <OfficerBox
          role="Email Person"
          name="Greg"
          college="Corpus Christi"
          jobDesc="Does boring email things!"
          email="secretary@cugcr.org.uk"
          picture={secretary}
        />
        <OfficerBox
          role="Less Important Leader"
          name="Jonathan"
          college="Selwyn"
          jobDesc="Tells us what to do in the RUBBISH CHURCH!"
          email="assistant.master@cugcr.org.uk"
          picture={assmaster}
        />
        <OfficerBox
          role="Repair Dude"
          name="Chris"
          college="King's"
          jobDesc="Fixes the bells when they break!"
          email="steeplekeeper@cugcr.org.uk"
          picture={steeplekeeper}
        />
        <OfficerBox
          role="Bookworm"
          name="Harry"
          college="John's"
          jobDesc="Sits in a room full of books all day!"
          email="librarian@cugcr.org.uk"
          picture={librarian}
        />
        <OfficerBox
          role="Teacher"
          name="Dima"
          college="Downing"
          jobDesc="Teaches us how to ring good!"
          email="teaching@cugcr.org.uk"
          picture={teaching}
        />
      </div>
    </WhiteDiv>
    <div
      style={{
        backgroundColor: "steelblue",
        display: "flex",
        padding: "1rem 1rem 1rem 1rem",
        justifyContent: "space-around",
        flexWrap: "wrap",
      }}
    >
      <WhiteDiv>
        <h3>Important Old People</h3>
        <p>
          Old Leader: Richard A Smith (Clare)
          <br />
          <br />
          Money Manager: David C W Richards (St John's)
          <br />
          <br />
          Anti-Stealing Officer: Frank H King (Magdalene)
        </p>
      </WhiteDiv>
      <WhiteDiv>
        <h3>We didn't even elect these guys</h3>
        <p>
          Master of the Web (that's me!!!): Thomas Haslam (Churchill) (
          <a href="mailto:webmaster@cugcr.org.uk">webmaster@cugcr.org.uk</a>)
          <br />
          <br />
          Mailman: Nicholas Small (
          <a href="mailto:addresslist@cugcr.org.uk">addresslist@cugcr.org.uk</a>
          )
        </p>
      </WhiteDiv>
      <WhiteDiv>
        <h3>Ambassadors to the BELL GOVERMENT</h3>
        <p>
          David C W Richards (St John's)
          <br />
          <br />
          Richard A Smith (Clare)
        </p>
      </WhiteDiv>
      <WhiteDiv>
        <h3>I literally just made these up</h3>
        <p>
          Admiral of the Cargo Fleet: Jadd Virji (
          <Email address="jv427@cam.ac.uk">cargofleet@cugcr.org.uk</Email>)
          <br />
          <br />
          Head Impostor (very sus!!!): Sam Johnson (
          <Email address="sdjohnson9801@gmail.com">impostor@cugcr.org.uk</Email>
          )
          <br />
          <br />
          Intoxicated Athletics Representative: Melissa Nash (
          <Email address="mfn28@cam.ac.uk">athletics@cugcr.org.uk</Email>)
          <br />
          <br />
          Police Relations Officer: John Hutchinson (
          <a href="https://www.police.uk/">police@cugcr.org.uk</a>)
        </p>
      </WhiteDiv>
    </div>
  </Layout>
)

export default About
